import { Controller } from '@hotwired/stimulus'

// Removes its host element when an action fires — e.g. a flash/toast dismiss
// button (data-action="dismiss#remove"). Replaces an inline onclick handler so a
// strict production Content-Security-Policy can forbid inline JS entirely.
export default class extends Controller {
  remove() {
    this.element.remove()
  }
}
